import { render, staticRenderFns } from "./SettingsCardProfile.vue?vue&type=template&id=c2023e94&scoped=true"
import script from "./SettingsCardProfile.vue?vue&type=script&lang=ts"
export * from "./SettingsCardProfile.vue?vue&type=script&lang=ts"
import style0 from "./SettingsCardProfile.vue?vue&type=style&index=0&id=c2023e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2023e94",
  null
  
)

export default component.exports